/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_LoadingInputs */

const en_clients_loading = /** @type {(inputs: Clients_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading clients…`)
};

const pt_br2_clients_loading = /** @type {(inputs: Clients_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando clientes…`)
};

/**
* | output |
* | --- |
* | "Loading clients…" |
*
* @param {Clients_LoadingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_loading = /** @type {((inputs?: Clients_LoadingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_LoadingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_loading(inputs)
	return pt_br2_clients_loading(inputs)
});